module.exports = __webpack_public_path__ + "img/mention-in-comment.f8033aa6.png";